var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resultForm"},[_vm._m(0),_c('div',{staticClass:"state"},[_vm._v("认证成功")]),(_vm.callBack || _vm.wxCallBack)?_c('div',{staticClass:"tag"},[_vm._v(" "+_vm._s(_vm.timer)+"s后返回 ")]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stateBg"},[_c('img',{attrs:{"src":require("@/assets/imgs/signSuccess.png"),"alt":""}})])
}]

export { render, staticRenderFns }